import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect, useState } from "react";
import { orderByBoolean } from "../../../../../../../../../common/util/Array/orderByBoolean";
import { User } from "../../../../../../../../shared/User/types";
import { ItemKey, PossessedItem } from "../items/types";
import { ItemShopButton } from "./ItemShopButton";
import { Record } from "./Record";

export function ItemList({
    possessedItems,
    itemKeyToFocus,
    user,
}: {
    possessedItems: PossessedItem[];
    itemKeyToFocus?: ItemKey;
    user: User;
}) {
    const c = useStyles();
    const { fixedItemKeyToFocus } = useFixedItemKeyToFocus(itemKeyToFocus);

    return (
        <Card className={c.container}>
            <ItemShopButton noItem={possessedItems.length === 0} />

            {orderByBoolean(
                possessedItems,
                item => item.item.key === fixedItemKeyToFocus
            ).map(({ item, num, isNew, isAdded }) => (
                <Record
                    key={item.key}
                    item={item}
                    num={num}
                    isNew={isNew}
                    isAdded={isAdded}
                    possessedItems={possessedItems}
                    isFocused={item.key === fixedItemKeyToFocus}
                    user={user}
                />
            ))}
        </Card>
    );
}
const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: theme.palette.grey[100],
        padding: "5px 5px 0",
        overflowY: "auto",
        maxHeight: 308,
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0,
    },
}));

function useFixedItemKeyToFocus(itemKeyToFocus?: ItemKey) {
    /**
     * After scrolling, itemKeyToFocus will be cleared. So, keep the fixed value.
     */
    const [fixedItemKeyToFocus, setFixedItemKeyToFocus] = useState<
        ItemKey | undefined
    >(undefined);

    useEffect(() => {
        if (!itemKeyToFocus) {
            return;
        }
        setFixedItemKeyToFocus(itemKeyToFocus);
    }, [itemKeyToFocus]);

    return { fixedItemKeyToFocus };
}
